import * as tslib_1 from "tslib";
import { Dropdown, DropdownMenuItemType, } from 'office-ui-fabric-react/lib/Dropdown';
import InboxRulesFolderDropdown from './FolderClauseValue';
import IncludesWordsInput from './IncludesWordsInput';
import getClauseTypeProperties from '../actions/helpers/getClauseTypeProperties';
import getExistingClauseTypesInSection from '../actions/helpers/getExistingClauseTypesInSection';
import getHeaderTextFromHeaderType from '../actions/helpers/getHeaderTextFromHeaderType';
import getImportanceOptions from '../actions/helpers/getImportanceOptions';
import getInboxRuleMessageFlagOptions from '../actions/helpers/getInboxRuleMessageFlagOptions';
import getInboxRuleMessageTypeOptions from '../actions/helpers/getInboxRuleMessageTypeOptions';
import getSensitivityOptions from '../actions/helpers/getSensitivityOptions';
import setClauseErrorText from '../actions/helpers/setClauseErrorText';
import setFocusedClauseId from '../actions/helpers/setFocusedClauseId';
import setIncludesWordsInputText from '../actions/helpers/setIncludesWordsInputText';
import removeClause from '../actions/removeClause';
import setClauseType from '../actions/setClauseType';
import setClauseValue from '../actions/setClauseValue';
import store from '../store/store';
import isValidClause from '../utils/isValidClause';
import { observer } from 'mobx-react';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import OWADatePicker from 'owa-datepicker';
import { now } from 'owa-datetime';
import ReadWriteRecipientWellWithFindControl from 'owa-readwrite-recipient-well/lib/components/ReadWriteRecipientWellWithFindControl';
import { RecipientType } from 'owa-recipient-common/lib/store/schema/RecipientType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import CategoryClauseValue from 'owa-inbox-rules-option/lib/components/CategoryClauseValue';
var styles = require('./InboxRuleClause.scss');
var classNames = require('classnames/bind').bind(styles);
var InboxRuleClause = /** @class */ (function (_super) {
    tslib_1.__extends(InboxRuleClause, _super);
    function InboxRuleClause() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getClauseValueInput = function () {
            var clauseId = _this.props.clauseId;
            var selectedClause = store.inboxRulesEditState.clauseMap.get(_this.props.clauseId);
            switch (selectedClause.clauseType) {
                case 'from':
                case 'to':
                case 'forwardTo':
                case 'forwardAsAttachmentTo':
                case 'redirectTo':
                    return _this.renderRecipientWell(selectedClause);
                case 'subjectIncludes':
                case 'subjectOrBodyIncludes':
                case 'inTheBody':
                case 'inTheSenderAddress':
                case 'inTheRecipientAddress':
                case 'inTheMessageHeader':
                    setIncludesWordsInputText(clauseId, '');
                    return _this.renderIncludesWordsInput(clauseId);
                case 'withImportance':
                case 'markImportance':
                    return _this.renderClauseValueDropdown(getImportanceOptions());
                case 'category':
                    return React.createElement(CategoryClauseValue, { clauseId: _this.props.clauseId });
                case 'sensitivity':
                    return _this.renderClauseValueDropdown(getSensitivityOptions());
                case 'flag':
                    return _this.renderClauseValueDropdown(getInboxRuleMessageFlagOptions());
                case 'type':
                    return _this.renderClauseValueDropdown(getInboxRuleMessageTypeOptions());
                case 'atLeast':
                case 'atMost':
                    return _this.renderNumberTextField(selectedClause);
                case 'moveTo':
                case 'copyTo':
                    return _this.renderFolderDropdown(clauseId);
                case 'onTheToOrCcLine':
                case 'theOnlyRecipientListed':
                case 'onTheToLine':
                case 'onTheCcLine':
                case 'notOnTheToLine':
                case 'attachment':
                case 'delete':
                case 'pin':
                case 'read':
                case 'junk':
                case 'any':
                case null:// no clause selected from the clause type dropdown ('select a clause')
                    return null; // No second input
                case 'before':
                case 'after':
                    return _this.renderDatePicker(selectedClause);
                // Other cases return null, default throw error
                default:
                    throw new Error('Cannot get clause value input for a clause type that does not exist');
            }
        };
        _this.onTextFieldChanged = function (value) {
            var num = Number(value);
            setClauseValue(num, _this.props.clauseId);
        };
        _this.onDateSelected = function (date) {
            setClauseValue(date, _this.props.clauseId);
        };
        _this.removeFocusAndValidate = function () {
            var clauseId = _this.props.clauseId;
            setClauseErrorText(clauseId, isValidClause(clauseId), store.inboxRulesEditState.clauseMap.get(_this.props.clauseId).clauseValue);
            setFocusedClauseId(clauseId, false /* shouldSetAsFocused */);
        };
        return _this;
    }
    InboxRuleClause.prototype.componentDidUpdate = function () {
        var _this = this;
        // set focus on input if clause type requires text input
        if (this.tryAutoFocus) {
            var selectedClause = store.inboxRulesEditState.clauseMap.get(this.props.clauseId);
            switch (selectedClause.clauseType) {
                case 'from':
                case 'to':
                    window.requestAnimationFrame(function () {
                        _this.recipientWellControl.focus();
                    });
                    break;
                case 'subjectIncludes':
                case 'subjectOrBodyIncludes':
                case 'inTheBody':
                case 'inTheSenderAddress':
                case 'inTheRecipientAddress':
                case 'inTheMessageHeader':
                    window.requestAnimationFrame(function () {
                        _this.includesWordsControl.focus();
                    });
                    break;
                default:
                    // not a clauseType that should gain focus
                    break;
            }
            this.tryAutoFocus = false;
        }
    };
    InboxRuleClause.prototype.render = function () {
        var _this = this;
        var clauseId = this.props.clauseId;
        var sectionType = this.props.sectionType;
        var selectedClause = store.inboxRulesEditState.clauseMap.get(clauseId);
        return (React.createElement("div", { className: styles.clauseContainer, key: clauseId },
            React.createElement(Dropdown, { onFocus: function () { return setFocusedClauseId(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return setFocusedClauseId(clauseId, false /* shouldSetAsFocused */); }, id: 'dropdown' + clauseId, placeHolder: strings.options_inboxRules_clauseTypeDropdownPlaceholder, options: this.getClauseDropdownOptions(), selectedKey: this.getDropdownKey(selectedClause.clauseType), className: styles.clauseTypesDropdown, onChanged: function (option) { return _this.onClauseTypeChanged(option); } }),
            this.getClauseValueInput(),
            this.shouldShowRemoveClauseButton() && (React.createElement(IconButton, { className: styles.removeClauseButton, iconProps: {
                    iconName: "Cancel" /* Cancel */,
                    styles: {
                        root: styles.cancelIcon,
                    },
                }, onClick: function () { return removeClause(clauseId, sectionType); } }))));
    };
    InboxRuleClause.prototype.getClauseDropdownOptions = function () {
        var items = [];
        var clauseId = this.props.clauseId;
        var sectionType = this.props.sectionType;
        var clauseTypeOptions = this.props.clauseTypeOptions;
        var existingClauseTypes = getExistingClauseTypesInSection(this.props.sectionType);
        var selectedClause = store.inboxRulesEditState.clauseMap.get(clauseId);
        var previousHeaderType = null;
        for (var i = 0; i < clauseTypeOptions.length; i++) {
            var clauseType = clauseTypeOptions[i];
            var isSelectedClauseType = selectedClause.clauseType == clauseType;
            var hasClauseType = existingClauseTypes.has(clauseType);
            // Do not add the clause type to the dropdown options if the clause type...
            // 1) is not the current clause's type AND
            // 2) has been used already OR
            // 3) is in exception section and the clause type is any since that is not a valid choice
            if ((!isSelectedClauseType && hasClauseType) ||
                (clauseType === 'category' && !isControlFeatureEnabled('tri-categories-parity')) ||
                (clauseType === 'any' && sectionType === 'exception')) {
                continue;
            }
            var clauseTypeProperties = getClauseTypeProperties(clauseType);
            var clauseHeaderType = clauseTypeProperties.headerType;
            // Only push a header if we are first element or if the next clause type's header is different than the previous's
            if (!previousHeaderType || clauseHeaderType != previousHeaderType) {
                items.push({
                    key: sectionType + clauseHeaderType,
                    text: getHeaderTextFromHeaderType(clauseHeaderType),
                    itemType: DropdownMenuItemType.Header,
                });
            }
            // If clause type is junk, need to make sure the segmentation settings have junk turned on before adding to dropdown
            if (clauseType !== 'junk' || getUserConfiguration().SegmentationSettings.JunkEMail) {
                items.push({
                    key: this.getDropdownKey(clauseType),
                    text: clauseTypeProperties.dropdownOptionText,
                    data: clauseTypeProperties,
                });
            }
            previousHeaderType = clauseHeaderType;
        }
        return items;
    };
    InboxRuleClause.prototype.getDropdownKey = function (clauseType) {
        return this.props.sectionType + clauseType;
    };
    InboxRuleClause.prototype.onClauseTypeChanged = function (clauseTypeDropdownOption) {
        var clauseId = this.props.clauseId;
        var clauseType = clauseTypeDropdownOption.data.clauseType;
        setClauseType(clauseType, clauseId);
        setClauseValue(clauseTypeDropdownOption.data.initialValue, clauseId);
        // clear the error text if the previous clause had invalid input
        setClauseErrorText(clauseId, true /* isValidClause */);
        this.tryAutoFocus = true;
    };
    InboxRuleClause.prototype.onClauseValueChanged = function (clauseValueDropdownOption) {
        var clauseId = this.props.clauseId;
        setClauseValue(clauseValueDropdownOption.data, clauseId);
        // clear the error text if the previous value was invalid
        setClauseErrorText(clauseId, true /* isValidClause */);
    };
    InboxRuleClause.prototype.renderIncludesWordsInput = function (clauseId) {
        var _this = this;
        var selectedClause = store.inboxRulesEditState.clauseMap.get(clauseId);
        return (React.createElement(IncludesWordsInput, { ref: function (ref) { return (_this.includesWordsControl = ref); }, clauseId: clauseId, placeHolderText: this.getIncludesWordsPlaceholderText(selectedClause.clauseType), onFocus: function () { return setFocusedClauseId(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); } }));
    };
    InboxRuleClause.prototype.renderClauseValueDropdown = function (dropdownOptionsData) {
        var _this = this;
        var dropdownOptions = [];
        var currentSelectedValue = store.inboxRulesEditState.clauseMap.get(this.props.clauseId)
            .clauseValue;
        var selectedKey = currentSelectedValue ? currentSelectedValue.toString() : null;
        var clauseId = this.props.clauseId;
        dropdownOptionsData.forEach(function (option) {
            dropdownOptions.push({
                key: option.value.toString(),
                text: option.text,
                data: option.value,
            });
        });
        return (React.createElement("div", { className: styles.clauseValueContainer },
            React.createElement(Dropdown, { onFocus: function () { return setFocusedClauseId(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); }, options: dropdownOptions, onChanged: function (option) { return _this.onClauseValueChanged(option); }, errorMessage: store.inboxRulesEditState.clauseErrorTextMap.get(clauseId), placeHolder: strings.options_inboxRules_clauseValueDropdownPlaceholder, selectedKey: selectedKey })));
    };
    InboxRuleClause.prototype.renderFolderDropdown = function (clauseId) {
        return React.createElement(InboxRulesFolderDropdown, { clauseId: clauseId });
    };
    InboxRuleClause.prototype.renderRecipientWell = function (selectedClause) {
        var _this = this;
        var clauseId = this.props.clauseId;
        var errorText = store.inboxRulesEditState.clauseErrorTextMap.get(this.props.clauseId);
        var value = store.inboxRulesEditState.clauseMap.get(this.props.clauseId)
            .clauseValue;
        var numPeople;
        var isFocused = store.inboxRulesEditState.focusedClauseId == clauseId;
        if (value && value.recipients.length) {
            numPeople = value.recipients.length;
        }
        else {
            numPeople = 0;
        }
        // we are in error state if there are no recipients selected and the find result is not showing (the user is not selecting a recipient)
        var shouldShowError = numPeople == 0 && !value.shouldShowFindResult;
        return (React.createElement("div", { className: styles.recipientWellContainer },
            React.createElement("div", { className: classNames(styles.recipientWell, errorText && shouldShowError && styles.hasError, isFocused && styles.focusBorder), tabIndex: -1, onFocus: function () { return setFocusedClauseId(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); } },
                React.createElement(ReadWriteRecipientWellWithFindControl, { ref: function (ref) { return (_this.recipientWellControl = ref); }, recipientWell: selectedClause.clauseValue, recipientType: RecipientType.None, size: 0 /* Small */ })),
            shouldShowError && React.createElement("span", { className: styles.errorText },
                " ",
                errorText,
                " ")));
    };
    InboxRuleClause.prototype.renderNumberTextField = function (selectedClause) {
        var _this = this;
        var clauseId = this.props.clauseId;
        return (React.createElement(TextField, { className: styles.clauseDateSizeValueContainer, onFocus: function () { return setFocusedClauseId(clauseId, true /* shouldSetAsFocused */); }, onBlur: function () { return _this.removeFocusAndValidate(); }, value: selectedClause.clauseValue.toString(), onChanged: this.onTextFieldChanged, errorMessage: store.inboxRulesEditState.clauseErrorTextMap.get(clauseId), suffix: strings.options_inboxRules_kb }));
    };
    InboxRuleClause.prototype.renderDatePicker = function (selectedClause) {
        var _this = this;
        var selectedClauseValue = selectedClause.clauseValue;
        var todayDate = new Date(now());
        var defaultDate = selectedClauseValue ? new Date(selectedClauseValue) : todayDate;
        return (React.createElement(OWADatePicker, { ref: function (ref) { return (_this.owaDatePickerControl = ref); }, className: styles.clauseDateSizeValueContainer, isMonthPickerVisible: false, value: defaultDate, onSelectDate: this.onDateSelected, minDate: todayDate }));
    };
    InboxRuleClause.prototype.getIncludesWordsPlaceholderText = function (clauseType) {
        return clauseType == 'inTheSenderAddress' || clauseType == 'inTheRecipientAddress'
            ? strings.options_inboxRules_addressIncludesOptionPlaceholder
            : strings.options_inboxRules_containsOptionPlaceholder;
    };
    // show remove clause button if there is more than one clause in conditional/action sections or for
    // any clause in the exception section
    InboxRuleClause.prototype.shouldShowRemoveClauseButton = function () {
        // always show for exceptions since it's an optional field
        return (this.props.sectionType == 'exception' ||
            // otherwise, show if there is more than one clause in conditional/action sections
            this.props.sectionClauseIds.length > 1);
    };
    InboxRuleClause = tslib_1.__decorate([
        observer
    ], InboxRuleClause);
    return InboxRuleClause;
}(React.Component));
export default InboxRuleClause;
//# sourceMappingURL=InboxRuleClause.js.map